import React from 'react';
import "./asn1-render.css"
import { useTranslation } from "react-i18next"

/** Renders a field value that may be a string or an array of strings */
const Asn1Field = ({ value }) => {
    if (!value && value !== 0) return null
    const items = Array.isArray(value) ? value : [value]
    return items.map((item, i) => <div key={i}>{item}</div>)
}

const Asn1DataTable = ({ data = [] }) => {
    const { t } = useTranslation()
    return (
        <div>
            {data.map((variable, index) => (
                <div className='digitalVaultDocumentAsn1' key={index}>
                    <table>
                        <div className='digitalVaultDocumentAsn1Title'>
                            {t("asn1Fields.label.metadata")}
                        </div>
                        <tbody>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.locality")}:</td>
                                <td><Asn1Field value={variable.localityName} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.stateOrProvince")}:</td>
                                <td><Asn1Field value={variable.stateOrProvinceName} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.country")}:</td>
                                <td><Asn1Field value={variable.countryName} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.postalCode")}:</td>
                                <td><Asn1Field value={variable.postalCode} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.address")}:</td>
                                <td><Asn1Field value={variable.streetAddress} /></td>
                            </tr>
                            <tr>
                                <td className='digitalVaultDocumentTr' colSpan="2"><hr style={{ border: 'none', borderTop: '1px solid #ccc', width: '100%' }} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.commonName")}:</td>
                                <td><Asn1Field value={variable.commonName} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.organizationalUnit")}:</td>
                                <td><Asn1Field value={variable.organizationalUnitName} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.organization")}:</td>
                                <td><Asn1Field value={variable.organizationName} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.email")}:</td>
                                <td><Asn1Field value={variable.emailAddress} /></td>
                            </tr>
                            <tr>
                                <td className='digitalVaultDocumentTr' colSpan="2"><hr style={{ border: 'none', borderTop: '1px solid #ccc', width: '100%' }} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.crl")}:</td>
                                <td><Asn1Field value={variable.cRLDistributionPoints} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.certificatePolicies")}:</td>
                                <td><Asn1Field value={variable.certificatePolicies} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.pscTimeValidated")}:</td>
                                <td><Asn1Field value={variable.pscTimeValidated} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.signingTime")}:</td>
                                <td><Asn1Field value={variable.signingTime} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
};

export default Asn1DataTable;

